import { useState, useEffect, useCallback } from 'react';
import { fetchYearlyTenantStats, fetchYearlySummary, fetchAvailableYears } from '../utils/api';

/**
 * Fetches the yearly summary and per-tenant stats, plus the list of years
 * that have data. Kept separate from useDashboard so changing the year does
 * not reload the monthly sections.
 * @param {number} selectedYear - Year (YYYY).
 * @param {number} [dbIndex] - 1-based database index.
 */
export function useYearlyStats(selectedYear, dbIndex) {
  const [years, setYears] = useState([]);
  const [tenantStats, setTenantStats] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [yearList, stats, sum] = await Promise.all([
        fetchAvailableYears(dbIndex),
        fetchYearlyTenantStats(selectedYear, dbIndex),
        fetchYearlySummary(selectedYear, dbIndex),
      ]);
      setYears(yearList);
      setTenantStats(stats);
      setSummary(sum);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [selectedYear, dbIndex]);

  useEffect(() => {
    load();
  }, [load]);

  return { years, tenantStats, summary, loading, error, refetch: load };
}
